import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface LoadingState {
  isLoading: boolean;
  message: string;
  icon?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<LoadingState>({
    isLoading: false,
    message: '',
    icon: undefined
  });

  public loading$: Observable<LoadingState> = this.loadingSubject.asObservable();

  /** @param icon Nome do ícone Lucide (calendar, refresh-cw, loader-2, save, check-circle, home) */
  show(message: string, icon?: string): void {
    this.loadingSubject.next({
      isLoading: true,
      message,
      icon
    });
  }

  hide(): void {
    this.loadingSubject.next({
      isLoading: false,
      message: '',
      icon: undefined
    });
  }

  get currentState(): LoadingState {
    return this.loadingSubject.value;
  }
}
